// Utility function to notify components about cart updates
export const notifyCartUpdate = () => {
  window.dispatchEvent(new CustomEvent('cartUpdated'));
};

